import { render, staticRenderFns } from "./PositionRecommendations.vue?vue&type=template&id=ac39dc28"
import script from "./PositionRecommendations.vue?vue&type=script&lang=js"
export * from "./PositionRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports